import styled from "styled-components";
import {StyledTable} from "../courierOnboardingTab/courierSummary/courierEquipmentInformations/CourierEquipmentInformations.styled";

export const ContentWrapper = styled.div`
    @media screen and (max-width: 768px) {
        padding: 12px 16px;

        > div:first-of-type {
            margin-bottom: 12px;
        }

        h3 {
            font-size: 16px;
        }
    }

    @media screen and (max-width: 480px) {
        padding: 8px 12px;

        > div:first-of-type {
            margin-bottom: 10px;
        }

        h3 {
            font-size: 15px;
        }
    }
`;

export const TableWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`;

export const ContractsTable = styled(StyledTable)`
    @media screen and (max-width: 768px) {
        width: 100% !important;

        .ant-table,
        .ant-table-container,
        .ant-table-content {
            width: 100% !important;
            max-width: 100% !important;
        }

        .ant-table table {
            width: 100% !important;
            min-width: 100% !important;
            table-layout: fixed !important;
        }

        .ant-table table colgroup {
            display: none !important;
        }

        .ant-table-tbody {
            display: block !important;
            width: 100% !important;
        }

        .ant-table table tbody tr {
            display: block !important;
            width: 100% !important;
            min-width: 100% !important;
            box-sizing: border-box;
            margin-bottom: 10px;
            border-radius: 8px;
        }

        .ant-table table tbody tr td {
            flex-wrap: wrap;
            min-height: 40px;
            padding: 8px 12px !important;
            gap: 8px;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 10px !important;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 10px !important;
        }

        .ant-table table td::before {
            min-width: 85px;
            max-width: 85px;
            font-size: 13px;
        }

        .ant-table table td > * {
            min-width: 0 !important;
            max-width: 100%;
            word-break: break-word;
            overflow-wrap: anywhere;
            display: flex !important;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 6px;
            justify-content: flex-end;
            align-items: center;
        }

        .ant-table table td > * .ant-tag,
        .ant-table table td > * span {
            word-break: break-word;
            overflow-wrap: anywhere;
            max-width: 100%;
        }

        /* Aksiyonlar: container genişliği boyunca */
        .ant-table table tbody tr td:last-child {
            flex-direction: column;
            align-items: stretch;
            gap: 8px;
        }

        .ant-table table tbody tr td:last-child::before {
            margin-bottom: 0;
        }

        .ant-table table tbody tr td:last-child > * {
            width: 100%;
            flex-wrap: wrap;
            justify-content: flex-start;
        }

        .ant-table table tbody tr td:last-child > * .ant-space,
        .ant-table table tbody tr td:last-child > .ant-space {
            width: 100%;
            display: flex !important;
            flex-wrap: wrap;
        }

        .ant-table table tbody tr td:last-child > * .ant-space-item,
        .ant-table table tbody tr td:last-child > .ant-space .ant-space-item {
            flex: 1;
            min-width: 80px;
        }

        .ant-table table tbody tr td:last-child .ant-btn {
            width: 100%;
            display: block;
            text-align: center;
            margin: 2px 0;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table tbody tr {
            margin-bottom: 8px;
            width: 100% !important;
            min-width: 100% !important;
        }

        .ant-table table tbody tr td {
            padding: 6px 10px !important;
            gap: 6px;
            min-height: 36px;
        }

        .ant-table table tbody tr td:first-child {
            padding-top: 8px !important;
        }

        .ant-table table tbody tr td:last-child {
            padding-bottom: 8px !important;
        }

        .ant-table table td::before {
            min-width: 75px;
            max-width: 75px;
            font-size: 12px;
        }

        .ant-table table td > * {
            font-size: 12px;
        }

        .ant-table table td > * .ant-btn {
            padding: 0 4px;
            font-size: 12px;
        }

        .ant-table table tbody tr td:last-child > * .ant-space-item,
        .ant-table table tbody tr td:last-child > .ant-space .ant-space-item {
            min-width: 70px;
        }
    }
`;
